'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _storage = require('./storage');

var _storage2 = _interopRequireDefault(_storage);

var _agentUtils = require('./live-person/agent-utils.js');

var _agentUtils2 = _interopRequireDefault(_agentUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surveyBotProjectId = 'css-survey-bot';

/**
 * Send survey data to hadoop via traffic
 *
 * @param {String} eventId The survey data event for traffic
 * @param {Array} data The survey data for the specific event
 * @private
 */
var sendSurveyData = function sendSurveyData(eventId, data) {
  if (window._trfq) {
    window._trfq.push(['cmdLogPageEvent', 'custom', eventId, data]);
  }
};

/**
 * Notifies this module of bot intents and associated bot project id.
 * Subequently sends data via traffic if associated with a survey bot.
 * Last engagement id is passed along to tie questions to a specific chat engagement
 *
 * @param {String} botProjectId The bot project sending the notification
 * @param {Object} eventData The event data for the specific bot intent
 * @public
 */
var notifyBotIntent = function notifyBotIntent(botProjectId, eventData) {
  if (botProjectId === surveyBotProjectId && eventData) {
    sendSurveyData('cx.help-bot.bot.survey.question', [['question', eventData.intent || ''], ['id', eventData.id || ''], ['bsid', eventData.bsid || ''], ['product', eventData.product || ''], ['engagementid', _storage2.default.getItem('lastEngagementId') || ''], ['agentname', _agentUtils2.default.getAgentName() || '']]);
  }
};

/**
 * Notifies this module of user utterances and associated bot project id.
 * Subequently sends data via traffic if associated with a survey bot.
 * Last engagement id is passed along to tie responses to a specific chat engagement
 *
 * @param {String} botProjectId The bot project sending the notification
 * @param {Object} eventData The event data for the specific bot intent
 * @public
 */
var notifyUserUtterance = function notifyUserUtterance(botProjectId, eventData) {
  if (botProjectId === surveyBotProjectId && eventData) {
    sendSurveyData('cx.help-bot.user.survey.response', [['response', eventData.utterance || ''], ['bsid', eventData.bsid || ''], ['product', eventData.product || ''], ['id', eventData.lastIntentId || ''], ['engagementid', _storage2.default.getItem('lastEngagementId') || ''], ['agentname', _agentUtils2.default.getAgentName() || '']]);
  }
};

exports.default = {
  surveyBotProjectId: surveyBotProjectId,
  notifyBotIntent: notifyBotIntent,
  notifyUserUtterance: notifyUserUtterance
};